class MatchColor {
  constructor() {
    // Initialize options from global variable
    try {
      if (typeof __options_name !== "undefined" && __options_name) {
        this.checkVariant = __options_name;
      } else {
        this.checkVariant = [];
      }
    } catch (err) {
      this.checkVariant = [];
    }

    // Initialize properties
    this.colorIndex = -1;
    this.fabricIndex = -1;
    this.results = [];
    this.selectedColor = null;
    this.fabric = {};
    this.selectedFabric = null;

    // Load product search results if available
    if (
      window.productSearchResults &&
      Array.isArray(window.productSearchResults)
    ) {
      this.results = window.productSearchResults;
    }

    // Add loading indicator to fabric wrapper
    if (this.results.length === 0) {
      jQuery("#loading-color").remove();
      jQuery(this.wrapperInputFabric).append(
        '<div id="loading-color">Loading...</div>',
      );
    }

    // Select variant inputs with broader selectors to match both old and new theme structures
    this.variantInputFabric = jQuery(
      ".variant-input input, .variant__fabric input, .variant__color input",
    );
    // console.log('MatchColor: Found variant inputs:', this.variantInputFabric.length);

    // Select wrapper elements with broader selectors
    this.wrapperInputFabric = jQuery(
      ".variant-input-wrap[data-section=optionfabric], .variant__fabric, fieldset[data-section=optionfabric]",
    );

    this.wrapperInputColor = jQuery(
      ".variant-input-wrap[data-section=optioncolor], .variant__color, fieldset[data-section=optioncolor]",
    );

    if (!window.isCanReqProductSearch && !window.canLinkVariantColor) return;

    if (!window.reqProductSearch) return;

    this.query = `/search?q=title:${encodeURI(window.reqProductSearch)} AND NOT (Sale)&view=colors`;

    jQuery(this.wrapperInputFabric).append(
      '<div id="loading-color">Loading...</div>',
    );

    if (window.searchVariantIncludedSale) {
      this.query = `/search?q=title:${encodeURI(window.reqProductSearch)}&view=colors`;
    }

    this.init();
  }

  init() {
    // Check if we have the necessary global variables
    if (!window.isCanReqProductSearch && !window.canLinkVariantColor) {
      console.warn(
        "MatchColor: Required global variables not set, initialization stopped",
      );
      return;
    }

    // Check if we have a product to search for
    if (!window.reqProductSearch) {
      console.warn(
        "MatchColor: No product search query, initialization stopped",
      );
      return;
    }

    // Check if we have product search results
    if (this.results.length === 0) {
      console.warn(
        "MatchColor: No product search results, initialization may be incomplete",
      );
    }

    // Get variant information
    this.getVariants();

    // Create color data from results
    this.createColorData();

    // Create UI elements for fabric and color dropdowns
    this.createElements();

    // Initialize mobile data handling
    this.mobileData();

    // Initialize popups
    this.popupDetailVariant();

    // Add click handlers for fabric and color options
    this.addClickHandlers();
  }

  // Add click handlers for fabric and color options
  addClickHandlers() {
    // Add click handlers for fabric options
    this.wrapperInputFabric
      .find(".bs__custom-option")
      .on("click", function (e) {
        e.preventDefault();
        const targetProductTitle = jQuery(this).attr("data-title");
        const fabricKey = jQuery(this).attr("data-fabric");
        const fabricName = jQuery(this).attr("data-fabric-name");

        // Get the URL from the href attribute
        const url = jQuery(this).attr("href");
        if (url && url !== "#") {
          window.location.href = url;
        }
      });

    // Add click handlers for color options
    this.wrapperInputColor.find(".bs__custom-option").on("click", function (e) {
      e.preventDefault();
      const targetProductTitle = jQuery(this).attr("data-title");
      const colorKey = jQuery(this).attr("data-color");
      const colorName = jQuery(this).attr("data-color-name");
      const isAvailable = jQuery(this).attr("data-available") === "true";

      // Get the URL from the href attribute
      const url = jQuery(this).attr("href");
      if (url && url !== "#") {
        window.location.href = url;
      }
    });
  }

  getVariants() {
    for (let l = 0; l < this.checkVariant.length; l++) {
      const variant = this.checkVariant[l];
      if (variant === "color") {
        this.colorIndex = l;
      }

      if (variant === "fabric") {
        this.fabricIndex = l;
      }
    }

    if (this.colorIndex > -1) {
      this.wrapperInputColor.addClass("__bs-has-colors-linked");
    }

    if (this.fabricIndex > -1) {
      this.wrapperInputFabric.addClass("__bs-has-colors-linked");
    }

    // Update selector to match new theme structure
    // Look for inputs in both old and new variant structures
    this.variantInputFabric = jQuery(
      ".variant-input input, .variant__fabric input, .variant__color input",
    );

    if (this.variantInputFabric && this.variantInputFabric.length > 0) {
      for (var i = 0; i < this.variantInputFabric.length; i++) {
        var input = this.variantInputFabric[i];
        var attr = jQuery(input).attr("name");

        if (attr === "Color") {
          this.selectedColor = input.value;
        }

        if (attr === "Fabric") {
          this.selectedFabric = input.value;
        }
      }
    } else {
      // Try to find checked inputs as a fallback
      const checkedInputs = jQuery('input[type="radio"]:checked');

      checkedInputs.each((index, input) => {
        const name = jQuery(input).attr("name");
        if (name === "Color") {
          this.selectedColor = input.value;
        }
        if (name === "Fabric") {
          this.selectedFabric = input.value;
        }
      });
    }

    this.createColorData();

    this.createElements();

    this.mobileData();
  }

  // update 2024-07-10
  sortFabric() {
    const self = this;
    const alphSortedFabric = Object.keys(this.fabric);
    alphSortedFabric.sort();
    let fabricList = (
      window.theme &&
      window.theme.settings &&
      window.theme.settings.fullFabricList
        ? window.theme.settings.fullFabricList
        : ""
    ).split("\n");

    fabricList = fabricList.map((item) =>
      item.replace(/\s/g, "").toLowerCase(),
    );
    fabricList = fabricList.filter((item) => alphSortedFabric.includes(item));
    fabricList = fabricList.filter(
      (value, index, array) => array.indexOf(value) === index,
    );
    alphSortedFabric.forEach((item) => {
      if (!fabricList.includes(item)) fabricList.push(item);
    });

    const ordered = {};
    fabricList.forEach((item) => {
      if (self.fabric[item] !== undefined) ordered[item] = self.fabric[item];
    });

    // console.log(alphSortedFabric)
    // console.log(fabricList)
    // console.log(ordered)

    return ordered;
  }

  createColorData() {
    const self = this;

    // Check if we have any results to process
    if (!this.results || this.results.length === 0) {
      return;
    }

    // Initialize fabric data
    this.fabric = {};

    // Check if we have results
    if (!this.results || this.results.length === 0) {
      // We'll continue and create default data below
    }

    // First pass: collect all fabrics
    for (let i = 0; i < this.results.length; i++) {
      const res = this.results[i];
      const variants = res.variants;

      if (variants) {
        // Get the fabric value
        const print = variants[`opt_${this.fabricIndex}`];

        if (print) {
          // Create a key for the fabric
          const name = print.replace(/\s/g, "").toLowerCase();

          // Initialize fabric data if not already present with target product title
          if (!this.fabric[name]) {
            this.fabric[name] = {
              name: print,
              url: res.url,
              colors: [],
              productTitle: res.title || "", // Add the target product title
            };
          }
        }
      }
    }

    // Second pass: collect all colors for each fabric
    for (let i = 0; i < this.results.length; i++) {
      const res = this.results[i];
      const variants = res.variants;
      const tags = res.tags || [];
      let isComingSoon = tags.includes("coming soon");

      if (variants) {
        // Get the fabric and color values
        const print = variants[`opt_${this.fabricIndex}`];
        const color = variants[`opt_${this.colorIndex}`];

        if (print && color) {
          // Create keys for fabric and color
          const fabricName = print.replace(/\s/g, "").toLowerCase();

          // Check if we have this fabric
          if (this.fabric[fabricName]) {
            // Check if we already have this color for this fabric
            const colorExists = this.fabric[fabricName].colors.some(
              (c) => c.name === color,
            );

            if (!colorExists) {
              // Add the color to the fabric with the target product title
              this.fabric[fabricName].colors.push({
                name: color,
                url: res.url,
                thumb: res.thumb || "",
                color_swatch_thumb1: variants.color_swatch_thumb1 || "",
                available: !isComingSoon,
                productTitle: res.title || "", // Add the target product title
              });
              //console.log('MatchColor: Added color:', color, 'to fabric:', print);
            }
          }
        }
      }
    }

    // If we have no fabrics, create default ones
    if (Object.keys(this.fabric).length === 0) {
      // Create a default fabric with the current product's fabric
      const defaultFabric =
        getCurrentVariantInfo().fabric || "Carvico VITA (ECONYL®) ♻";
      const defaultFabricKey = defaultFabric.replace(/\s/g, "").toLowerCase();
      const currentProductTitle = jQuery(
        "h1.product__title, .product-single__title, .product__title, h1[data-product-title]",
      )
        .first()
        .text()
        .trim();

      this.fabric[defaultFabricKey] = {
        name: defaultFabric,
        url: window.location.pathname,
        colors: [],
        productTitle: currentProductTitle, // Add current product title as fallback
      };

      // Add some fallback fabrics
      const fallbackFabrics = [
        "BS Shiny",
        "Carvico Ibiza",
        "Carvico Pantelleria ♻",
        "JL Renew Pop (ECONYL®) ♻",
      ];

      fallbackFabrics.forEach((fabric) => {
        const fabricKey = fabric.replace(/\s/g, "").toLowerCase();
        if (!this.fabric[fabricKey]) {
          this.fabric[fabricKey] = {
            name: fabric,
            url: `${window.location.pathname}?variant=fabric:${encodeURIComponent(fabric)}`,
            colors: [],
            productTitle: currentProductTitle, // Add current product title as fallback
          };
        }
      });
    }

    // If any fabric has no colors, add default colors - di disable krna ngaruh ke hardware
    Object.keys(this.fabric).forEach((fabricKey) => {
      //if (this.fabric[fabricKey].colors.length === 0) {
      //console.warn(`MatchColor: No colors found for fabric ${this.fabric[fabricKey].name}, adding defaults`);
      // Add default colors to the fabric
      //const defaultColors = ['Nero Bianco', 'Bianco', 'Nero', 'Rosso', 'Blu', 'Verde'];
      //const currentProductTitle = jQuery('h1.product__title, .product-single__title, .product__title, h1[data-product-title]').first().text().trim();
      //defaultColors.forEach(color => {
      //this.fabric[fabricKey].colors.push({
      //name: color,
      //url: `${this.fabric[fabricKey].url}?variant=color:${encodeURIComponent(color)}`,
      //thumb: jQuery('.product__thumb-item img').first().attr('src') || '',
      //color_swatch_thumb1: jQuery('.color-swatch').first().css('background-image') || '',
      //available: true,
      //productTitle: currentProductTitle // Add current product title as fallback
      //});
      //});
      //}
    });

    // Set the selected fabric if we have one
    if (this.fabricIndex > -1) {
      const selectedFabric = jQuery(
        `input[name="option${this.fabricIndex + 1}"]:checked`,
      ).val();
      if (selectedFabric) {
        const fabricKey = selectedFabric.replace(/\s/g, "").toLowerCase();
        if (this.fabric[fabricKey]) {
          this.selectedFabric = fabricKey;
        }
      }
    }

    // Set the selected color if we have one
    if (this.colorIndex > -1) {
      const selectedColor = jQuery(
        `input[name="option${this.colorIndex + 1}"]:checked`,
      ).val();
      if (selectedColor) {
        this.selectedColor = selectedColor;
      }
    }

    // Log the final fabric data
  }

  mobileData() {
    //console.log('MatchColor: mobileData called');
    const self = this;

    // Check if we're on a mobile device
    if (window.innerWidth < 600) {
      // Find dropdown containers - use more flexible selectors to match both old and new theme
      const colorDD = $(
        ".__bs-color-dd, .variant__color, fieldset[data-section=optioncolor]",
      );
      const fabricDD = $(
        ".__bs-fabric-dd, .variant__fabric, fieldset[data-section=optionfabric]",
      );

      // Find input containers - use more flexible selectors
      const colorInput = $(
        ".variant-type-color, .variant__color, fieldset[data-section=optioncolor]",
      );
      const fabricInput = $(
        ".variant-type-fabric, .variant__fabric, fieldset[data-section=optionfabric]",
      );

      jQuery(colorInput).addClass("bs__mobile__search");
      jQuery(fabricInput).addClass("bs__mobile__search");

      const ddElements = [
        {
          id: "dolor",
          elem: colorDD,
          isActive: false,
          inputsElem: colorInput,
          fieldId: "Color",
          header: "Choose Color",
        },

        {
          id: "fabric",
          elem: fabricDD,
          isActive: false,
          inputsElem: fabricInput,
          fieldId: "Fabric",
          header: "Choose Fabric",
        },
      ];

      const dropDownAction = function (data) {
        if (data.elem) {
          const fieldName = $(".product-single__form").find(
            `.variant-input-wrap[name="${data.fieldId}"]`,
          );

          $(data.elem).html($(data.inputsElem).html());
          $(data.elem).find(".variant-input").first().remove();

          var buttonTitle = $(data.elem).find(
            ".variant-title-container .variant__label",
          );
          var field = $(data.elem).find(".variant-input-wrap");

          $(buttonTitle).click(function () {
            if ($(data.elem).hasClass("active")) {
              $(data.elem).removeClass("active");
              data.isActive = false;
            } else {
              $(data.elem).addClass("active");
              setTimeout(function () {
                data.isActive = true;
              }, 150);
            }
          });

          $(field).prepend(
            $(
              `<div class="bs__dd-label-name ${data.header ? "dd-has-header-label" : ""}">${data.header}</div>`,
            ),
          );

          /*
					  If field name exist then get the default input value
					*/
          if (fieldName) {
            var getFirstElement = $(fieldName).find(".variant-input").first();
            var selectedName = $(getFirstElement).attr("data-value");
            // $(buttonTitle).find('.selected-name').text(self.toTitleCase(selectedName))
            $(buttonTitle).find(".selected-name").text(selectedName);
          }
        }
      };

      for (var i = 0; i < ddElements.length; i++) {
        var DD = ddElements[i];
        dropDownAction(DD);
      }

      $(document).on("click", function (event) {
        for (var i = 0; i < ddElements.length; i++) {
          var DD = ddElements[i];
          var inputWrapper = $(DD.elem).find(".variant-input-wrap");
          if (!$(event.target).closest(inputWrapper).length) {
            if (DD.isActive) {
              $(DD.elem).removeClass("active");
              DD.isActive = false;
            }
          }
        }
      });
    }

    var colorsContainer = document.querySelectorAll(".bs__color-container");
    if (colorsContainer) {
      for (var i = 0; i < colorsContainer.length; i++) {
        var container = colorsContainer[i];
        var labelName = container.querySelector(".bs__color-label-name");
        var colorLable = container.querySelector(".color-swatch");
        if (labelName && colorLable) {
          var width = labelName.offsetWidth;
          var colorWidth = colorLable.offsetWidth;
          var colorXCenter = colorWidth / 2;

          labelName.style.left = `-${width / 2 - colorXCenter}px`;
        }
      }
    }
  }

  toTitleCase(str) {
    return str.toLowerCase().replace(/\b\w/g, function (char) {
      return char.toUpperCase();
    });
  }

  // Helper function to determine if two product titles should share colors
  shouldShareColors(currentTitle, targetTitle) {
    if (!currentTitle || !targetTitle) return false;

    // Exact match
    if (currentTitle.toLowerCase() === targetTitle.toLowerCase()) {
      return true;
    }

    // List of exclusionary words that indicate different product variants
    const exclusionaryWords = [
      "corsage",
      "premium",
      "deluxe",
      "special",
      "limited",
      "edition",
      "pro",
      "plus",
      "advanced",
      "enhanced",
      "upgraded",
      "signature",
      "collection",
      "series",
      "exclusive",
      "luxury",
      "classic",
    ];

    // Extract base product codes and main descriptions
    const extractBaseInfo = (title) => {
      // Remove common suffixes and normalize
      const cleaned = title
        .toLowerCase()
        .replace(/\s*-\s*[a-z\s]*$/i, "") // Remove color/variant suffixes
        .trim();

      // Split into words and filter out very common words
      const words = cleaned
        .split(/[\s-]+/)
        .filter(
          (word) =>
            word.length > 2 &&
            !["the", "and", "with", "one", "piece", "suit"].includes(word),
        );

      // Identify exclusionary words
      const exclusionaryWordsFound = words.filter((word) =>
        exclusionaryWords.includes(word.toLowerCase()),
      );

      return {
        original: title,
        cleaned: cleaned,
        words: words,
        productCode: words[0] || "", // First word is usually the product code
        mainWords: words.slice(1), // Rest are descriptive words
        exclusionaryWords: exclusionaryWordsFound,
      };
    };

    const current = extractBaseInfo(currentTitle);
    const target = extractBaseInfo(targetTitle);

    // Must have same product code
    if (current.productCode !== target.productCode) {
      console.log(
        "MatchColor: Different product codes:",
        current.productCode,
        "vs",
        target.productCode,
      );
      return false;
    }

    // Check for exclusionary words - if one has exclusionary words and the other doesn't, they shouldn't share
    const currentHasExclusionary = current.exclusionaryWords.length > 0;
    const targetHasExclusionary = target.exclusionaryWords.length > 0;

    if (currentHasExclusionary !== targetHasExclusionary) {
      console.log(
        "MatchColor: One title has exclusionary words, the other doesn't:",
        {
          currentExclusionary: current.exclusionaryWords,
          targetExclusionary: target.exclusionaryWords,
        },
      );
      return false;
    }

    // If both have exclusionary words, they must match exactly
    if (currentHasExclusionary && targetHasExclusionary) {
      const exclusionaryMatch =
        current.exclusionaryWords.every((word) =>
          target.exclusionaryWords.includes(word),
        ) &&
        target.exclusionaryWords.every((word) =>
          current.exclusionaryWords.includes(word),
        );

      if (!exclusionaryMatch) {
        console.log(
          "MatchColor: Different exclusionary words - not sharing colors",
        );
        return false;
      }
    }

    // Check if main descriptive words are similar enough (excluding exclusionary words)
    const currentMainWords = current.mainWords.filter(
      (word) => !exclusionaryWords.includes(word.toLowerCase()),
    );
    const targetMainWords = target.mainWords.filter(
      (word) => !exclusionaryWords.includes(word.toLowerCase()),
    );

    let matchingWords = 0;
    const longerLength = Math.max(
      currentMainWords.length,
      targetMainWords.length,
    );
    const shorterLength = Math.min(
      currentMainWords.length,
      targetMainWords.length,
    );

    currentMainWords.forEach((currentWord) => {
      if (
        targetMainWords.some(
          (targetWord) =>
            currentWord.includes(targetWord) ||
            targetWord.includes(currentWord) ||
            currentWord === targetWord,
        )
      ) {
        matchingWords++;
      }
    });

    // Require higher similarity when one title is significantly longer
    const lengthDifference = longerLength - shorterLength;
    let requiredPercentage = 0.7; // Default 70%

    if (lengthDifference >= 2) {
      requiredPercentage = 0.9; // Require 90% similarity for significantly different lengths
    } else if (lengthDifference >= 1) {
      requiredPercentage = 0.85; // Require 85% similarity for moderate difference
    }

    // Use the longer length as the base for percentage calculation
    const matchPercentage = longerLength > 0 ? matchingWords / longerLength : 0;
    const shouldShare = matchPercentage >= requiredPercentage;

    console.log("MatchColor: Title matching result:", {
      matchingWords,
      currentMainWords,
      targetMainWords,
      longerLength,
      lengthDifference,
      requiredPercentage: Math.round(requiredPercentage * 100) + "%",
      actualPercentage: Math.round(matchPercentage * 100) + "%",
      shouldShare,
    });

    return shouldShare;
  }

  createElements() {
    console.log("MatchColor: createElements called");
    var self = this;

    // Clear any existing loading indicators
    jQuery("#loading-color").remove();

    // Get current product title for fabric filtering as well
    const currentProductTitle = jQuery(
      "h1.product__title, .product-single__title, .product__title, h1[data-product-title]",
    )
      .first()
      .text()
      .trim();
    console.log(
      "MatchColor: Current product title for fabric filtering:",
      currentProductTitle,
    );

    // Check if fabric data exists
    if (this.fabric && Object.keys(this.fabric).length > 0) {
      // First clear any existing fabric options to avoid duplicates
      this.wrapperInputFabric
        .find(".bs__custom-option, .bs__fabric-options-container")
        .remove();

      // Create a container for fabric options
      const fabricContainer = jQuery(
        '<div class="bs__fabric-options-container"></div>',
      );
      this.wrapperInputFabric.append(fabricContainer);

      // Get current selected fabric from radio buttons
      if (!this.selectedFabric && this.fabricIndex > -1) {
        const selectedFabricInput = jQuery(
          `input[name="option${this.fabricIndex + 1}"]:checked, input[name="Fabric"]:checked`,
        );
        if (selectedFabricInput.length > 0) {
          const selectedFabricValue = selectedFabricInput.val();
          const fabricKey = selectedFabricValue
            .replace(/\s/g, "")
            .toLowerCase();
          this.selectedFabric = fabricKey;
          console.log(
            "MatchColor: Selected fabric from input:",
            selectedFabricValue,
          );

          // Add active class to the parent div of the selected fabric input
          const parentDiv = selectedFabricInput.closest(".variant-input");
          if (parentDiv.length > 0) {
            // Remove active class from all siblings
            parentDiv.siblings(".variant-input").removeClass("active");
            // Add active class to this one
            parentDiv.addClass("active");
          }
        }
      }

      // Filter and create fabric options based on title matching
      let fabricsProcessed = 0;
      let fabricsFiltered = 0;

      for (const key in this.fabric) {
        if (this.fabric.hasOwnProperty(key)) {
          const data = this.fabric[key];
          const colors = data.colors || [];

          // Check if this fabric should be included based on title matching
          const fabricProductTitle = data.productTitle || "";
          const shouldIncludeFabric = this.shouldShareColors(
            currentProductTitle,
            fabricProductTitle,
          );

          if (!shouldIncludeFabric) {
            fabricsFiltered++;

            continue;
          }

          fabricsProcessed++;

          let classFabActive = "";

          // Check if this is the selected fabric
          const fabricKey = data.name.replace(/\s/g, "").toLowerCase();

          // Get the currently selected fabric from the radio button
          const selectedFabricInput = jQuery(
            `input[name="option${this.fabricIndex + 1}"]:checked, input[name="Fabric"]:checked`,
          );
          const selectedFabricValue =
            selectedFabricInput.length > 0 ? selectedFabricInput.val() : "";

          // Check if this fabric matches the selected one
          if (
            data.name === selectedFabricValue ||
            (!selectedFabricValue && fabricsProcessed === 1)
          ) {
            classFabActive = "active";
            this.selectedFabric = fabricKey;
          }

          // Create fabric button with dynamic data-title (using target product title)
          const fallbackTitle = currentProductTitle;
          const targetProductTitle = data.productTitle || fallbackTitle;

          const fabricsButton =
            jQuery(`<a class="bs__custom-option ${classFabActive}" href="${data.url || "#"}" data-title="${targetProductTitle}" data-fabric="${key}" data-fabric-name="${data.name}" data-type="fabric">
			                        			<div class="variant-input">
			                        				<label class="">${data.name}</label>
			                        			</div>
			                        		</a>`);

          // Add click event to fabric button
          fabricsButton.on("click", function (e) {
            e.preventDefault();
            console.log("MatchColor: Fabric clicked:", data.name);

            // Find and activate the corresponding radio button
            const fabricInput = jQuery(
              `input[name="option${self.fabricIndex + 1}"][value="${data.name}"], input[name="Fabric"][value="${data.name}"]`,
            );
            if (fabricInput.length > 0) {
              // Check the radio button
              fabricInput.prop("checked", true).trigger("change");

              // Add active class to the parent div
              const parentDiv = fabricInput.closest(".variant-input");
              if (parentDiv.length > 0) {
                // Remove active class from all siblings
                parentDiv.siblings(".variant-input").removeClass("active");
                // Add active class to this one
                parentDiv.addClass("active");
              }
            }

            // Navigate to the fabric URL
            if (data.url) {
              window.location.href = data.url;
            }
          });

          // Append fabric button to container
          fabricContainer.append(fabricsButton);

          // If this is the selected fabric, create color options
          if (classFabActive === "active") {
            this.createColorOptions(colors);
          }
        }
      }
    }
  }
  createColorOptions(colors) {
    const self = this;

    // Clear any existing color options
    this.wrapperInputColor
      .find(".bs__custom-option, .bs__color-options-container")
      .remove();

    // Get current product title for title matching
    const currentProductTitle = jQuery(
      "h1.product__title, .product-single__title, .product__title, h1[data-product-title]",
    )
      .first()
      .text()
      .trim();

    // Filter colors to only include those from products with matching titles
    const filteredColors = [];
    let filteredCount = 0;

    if (colors && colors.length > 0) {
      colors.forEach((color, index) => {
        const targetTitle = color.productTitle || "";
        const shouldInclude = self.shouldShareColors(
          currentProductTitle,
          targetTitle,
        );

        if (shouldInclude) {
          filteredColors.push(color);
        } else {
          filteredCount++;
        }
      });
    }

    // Create a container for color options
    const colorContainer = jQuery(
      '<div class="bs__color-options-container"></div>',
    );
    this.wrapperInputColor.append(colorContainer);

    // Get current selected color from radio buttons
    if (!this.selectedColor && this.colorIndex > -1) {
      const selectedColorInput = jQuery(
        `input[name="option${this.colorIndex + 1}"]:checked, input[name="Color"]:checked`,
      );
      if (selectedColorInput.length > 0) {
        this.selectedColor = selectedColorInput.val();

        // Add active class to the parent div of the selected color input
        const parentDiv = selectedColorInput.closest(".variant-input");
        if (parentDiv.length > 0) {
          // Remove active class from all siblings
          parentDiv.siblings(".variant-input").removeClass("active");
          // Add active class to this one
          parentDiv.addClass("active");
        }
      }
    }

    // Create color options from filtered colors
    if (filteredColors && filteredColors.length > 0) {
      for (let i = 0; i < filteredColors.length; i++) {
        const color = filteredColors[i];
        const name = color.name;
        const url = color.url || "#";
        let classColorActive = "";
        let colorName = name.toLowerCase();
        let notAvailableClass = "";
        const splitColor = name.split(" ");

        // Check if this is the selected color
        if (name === this.selectedColor || (!this.selectedColor && i === 0)) {
          classColorActive = "active";
          this.selectedColor = name;
          console.log("MatchColor: Found active color:", name);
        }

        // Check if color is available
        if (color.available === false) {
          notAvailableClass = "bs__item-not-available";
        }

        // Extract color name for background
        if (splitColor && splitColor.length > 0) {
          colorName = splitColor[splitColor.length - 1].toLowerCase();
        }

        // Handle thumbnail URL - use the color name directly for the image
        let thumb = "";

        // Format the color name for the image URL
        let imageName = name
          .replace(/[&\/\\#,+()$~%.'":*?<>{}]/g, "")
          .toLowerCase();
        imageName = imageName.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
        imageName = imageName.replace(/\s/g, "-");

        // Use the Shopify CDN URL pattern for assets
        thumb = `https://shop.baliswim.com/cdn/shop/t/74/assets/${imageName}`;
        //console.log('Color swatch image URL:', thumb);

        // Calculate the left position for the color label based on name length
        const labelWidth = name.length * 2.5; // Approximate width based on character count
        const leftPosition = -labelWidth;

        // Create color button with styling similar to the old theme and dynamic data-title (using target product title)
        const fallbackTitle = jQuery(
          "h1.product__title, .product-single__title, .product__title, h1[data-product-title]",
        )
          .first()
          .text()
          .trim();
        const targetProductTitle = color.productTitle || fallbackTitle;
        const colorsButton =
          jQuery(`<a class="bs__custom-option bs__color-container ${classColorActive} dynamic" href="${url}" data-title="${targetProductTitle}" data-color="${colorName}" data-color-name="${name}" data-type="color" data-available="${color.available !== false}">
					<div class="bs__color-label-name" style="left: ${leftPosition}px;">${self.toTitleCase(name)}</div>
					<div class="variant-input">
						<label class="color-swatch color-swatch--zebra-snake ${notAvailableClass}"
							style="background-image: url(${thumb}_50x.png); background-color: ${colorName};">
							${self.toTitleCase(name)}
						</label>
					</div>
				</a>`);

        // Add click event to color button
        colorsButton.on("click", function (e) {
          e.preventDefault();

          // Find and activate the corresponding radio button
          const colorInput = jQuery(
            `input[name="option${self.colorIndex + 1}"][value="${name}"], input[name="Color"][value="${name}"]`,
          );
          if (colorInput.length > 0) {
            // Check the radio button
            colorInput.prop("checked", true).trigger("change");

            // Add active class to the parent div
            const parentDiv = colorInput.closest(".variant-input");
            if (parentDiv.length > 0) {
              // Remove active class from all siblings
              parentDiv.siblings(".variant-input").removeClass("active");
              // Add active class to this one
              parentDiv.addClass("active");
            }
          }

          // Navigate to the color URL
          if (url && url !== "#") {
            window.location.href = url;
          }
        });

        // Append color button to container
        colorContainer.append(colorsButton);
      }
    } else {
      console.log("MatchColor: No colors to display after filtering");
    }

    // Log final summary
    console.log("MatchColor: Color options created:", {
      originalColorCount: colors ? colors.length : 0,
      filteredColorCount: filteredColors.length,
      colorsDisplayed: filteredColors.map(
        (c) => `${c.name} (${c.productTitle})`,
      ),
      currentProduct: currentProductTitle,
    });
  }
  popupDetailVariant() {
    const popupContentButtons = jQuery(".__bs-learn-more");

    if (popupContentButtons) {
      for (var i = 0; i < popupContentButtons.length; i++) {
        var button = popupContentButtons[i];
        jQuery(button).click(function () {
          var popupId = jQuery(this).attr("data-popup-id");
          if (popupId) {
            var buttonClose = jQuery(`#${popupId}`).find(".button-close");

            jQuery(document.body).css({
              overflow: "hidden",
            });
            jQuery(`#${popupId}`).addClass("active");

            if (buttonClose) {
              jQuery(buttonClose).click(function () {
                jQuery(`#${popupId}`).removeClass("active");
                jQuery(document.body).css({
                  overflow: "auto",
                });
              });
            }
          }
        });
      }
    }
  }

  matchByTag() {
    var newResults = [];
    if (window.searchByTags) {
      this.results.map(function (item) {
        if (item.tags.indexOf(window.searchByTags) > -1) {
          newResults.push(item);
        }
      });

      this.results = newResults;
    }
  }

  productsSizeExcludeCurrentProduct() {
    const productId = window.__productId;
    const colorsInputs = document.querySelectorAll(
      ".variant__color .variant-input",
    );
    const colorsInputsWrapper = document.querySelector(".variant__color");

    if (productId) {
      var filter = this.results.filter(function (item) {
        return item.id !== productId;
      });

      if (filter.length === 0 && colorsInputs.length > 1) {
        colorsInputsWrapper.classList.add("show-color-inputs");
      }
    }
  }

  init() {
    const self = this;
    jQuery.getJSON(this.query, function (data, status) {
      self.results = data.results;
      self.productsSizeExcludeCurrentProduct();

      if (!self.results) return;

      self.matchByTag();

      self.getVariants();

      setTimeout(function () {
        self.popupDetailVariant();
      }, 100);
    });
  }
}

function linkUpColorProduct(onComplete) {
  console.log("linkUpColorProduct called");

  // Make sure jQuery is available
  if (typeof jQuery === "undefined") {
    console.error("jQuery is not loaded, cannot initialize MatchColor");
    return;
  }

  // Check if required global variables are set
  if (!window.reqProductSearch) {
    console.error(
      "reqProductSearch is not defined, cannot initialize MatchColor",
    );
    return;
  }

  // Set up global variables if not already set
  window.isCanReqProductSearch = window.isCanReqProductSearch || true;
  window.canLinkVariantColor = window.canLinkVariantColor || true;

  // Wait for DOM to be fully ready
  jQuery(function () {
    console.log("DOM ready, initializing MatchColor");

    // Check if we have the necessary elements
    const hasVariants =
      jQuery(".variant-input, .variant__fabric, .variant__color").length > 0;

    if (hasVariants) {
      // Fetch product data
      fetchProductData(function (data) {
        // Initialize the MatchColor class
        const matchColor = new MatchColor();

        // Call onComplete callback if provided
        if (typeof onComplete === "function") {
          onComplete(matchColor);
        }
      });
    } else {
      console.warn(
        "No variant elements found, delaying MatchColor initialization",
      );

      // Try again after a short delay
      setTimeout(function () {
        console.log("Retrying MatchColor initialization");
        linkUpColorProduct(onComplete);
      }, 500);
    }
  });
}

// Function to fetch product data
function fetchProductData(callback) {
  console.log("Fetching product data for:", window.reqProductSearch);

  // Construct the query URL
  let query = `/search?q=title:${encodeURI(window.reqProductSearch)}&view=colors`;

  // Add NOT (Sale) to exclude sale items unless specifically included
  if (!window.searchVariantIncludedSale) {
    query = `/search?q=title:${encodeURI(window.reqProductSearch)} AND NOT (Sale)&view=colors`;
  }

  console.log("Query URL:", query);

  // Make the AJAX request
  jQuery.ajax({
    url: query,
    type: "GET",
    dataType: "json",
    success: function (data) {
      console.log("Product data fetched successfully:", data);

      // Store the results globally for the MatchColor class to use
      window.productSearchResults = data.results || [];

      // Call the callback with the data
      if (typeof callback === "function") {
        callback(data.results || []);
      }
    },
    error: function (xhr, status, error) {
      console.error("Error fetching product data:", error);

      // Call the callback with no data
      if (typeof callback === "function") {
        callback([]);
      }
    },
  });
}

// Function to create mock product data
function createMockProductData(productHandle, productTitle) {
  console.log("Creating mock data for product:", productHandle);

  // Get the current variant information
  const currentVariant = getCurrentVariantInfo();
  console.log("Current variant info:", currentVariant);

  // Create a basic result for the current product
  const result = [
    {
      title: productTitle,
      url: `/products/${productHandle}`,
      thumb: jQuery(".product__thumb-item img").first().attr("src") || "",
      variants: {
        opt_0: currentVariant.size || "S",
        opt_1: currentVariant.fabric || "Carvico VITA (ECONYL®) ♻",
        opt_2: currentVariant.color || "Nero Bianco",
        available: true,
        color_swatch_thumb1:
          jQuery(".color-swatch").first().css("background-image") || "",
      },
      tags: [],
    },
  ];

  // Add mock data for different fabric options
  addMockFabricOptions(result, productHandle, productTitle);

  // Add mock data for different color options
  addMockColorOptions(
    result,
    productHandle,
    productTitle,
    currentVariant.fabric,
  );

  return result;
}

// Function to get current variant information
function getCurrentVariantInfo() {
  // Try to get variant info from the selected variant
  const variantInfo = {
    size: "",
    fabric: "",
    color: "",
  };

  // Get size from selected radio button
  const sizeInput = jQuery('input[name="Size"]:checked');
  if (sizeInput.length > 0) {
    variantInfo.size = sizeInput.val();
  }

  // Get fabric from selected radio button
  const fabricInput = jQuery('input[name="Fabric"]:checked');
  if (fabricInput.length > 0) {
    variantInfo.fabric = fabricInput.val();
  }

  // Get color from selected radio button
  const colorInput = jQuery('input[name="Color"]:checked');
  if (colorInput.length > 0) {
    variantInfo.color = colorInput.val();
  }

  return variantInfo;
}

// Function to add mock fabric options
function addMockFabricOptions(result, productHandle, productTitle) {
  // List of common fabrics used in the shop
  const fabrics = [
    "Carvico VITA (ECONYL®) ♻",
    "BS Shiny",
    "Carvico Ibiza",
    "Carvico Pantelleria ♻",
    "JL Renew Pop (ECONYL®) ♻",
  ];

  // Add a result for each fabric
  fabrics.forEach((fabric) => {
    // Skip if this fabric is already in the result
    if (result.some((r) => r.variants && r.variants.opt_1 === fabric)) {
      return;
    }

    // Add a new result for this fabric
    result.push({
      title: productTitle,
      url: `/products/${productHandle}?variant=fabric:${encodeURIComponent(fabric)}`,
      thumb: jQuery(".product__thumb-item img").first().attr("src") || "",
      variants: {
        opt_0: "S",
        opt_1: fabric,
        opt_2: "Nero Bianco",
        available: true,
        color_swatch_thumb1:
          jQuery(".color-swatch").first().css("background-image") || "",
      },
      tags: [],
    });
  });
}

// Function to add mock color options
function addMockColorOptions(result, productHandle, productTitle, fabric) {
  // List of common colors used in the shop
  const colors = ["Nero Bianco", "Bianco", "Nero", "Rosso", "Blu", "Verde"];

  // Add a result for each color
  colors.forEach((color) => {
    // Skip if this color is already in the result for the current fabric
    if (
      result.some(
        (r) =>
          r.variants &&
          r.variants.opt_1 === fabric &&
          r.variants.opt_2 === color,
      )
    ) {
      return;
    }

    // Add a new result for this color
    result.push({
      title: productTitle,
      url: `/products/${productHandle}?variant=color:${encodeURIComponent(color)}`,
      thumb: jQuery(".product__thumb-item img").first().attr("src") || "",
      variants: {
        opt_0: "S",
        opt_1: fabric || "Carvico VITA (ECONYL®) ♻",
        opt_2: color,
        available: true,
        color_swatch_thumb1:
          jQuery(".color-swatch").first().css("background-image") || "",
      },
      tags: [],
    });
  });
}
